import { BadgePercent } from 'lucide-react';

/**
 * How the storefront banner reads, in both languages. A preview only: the storefront has its own
 * styling per brand.
 */
export function BannerPreview({
  titleEn,
  textEn,
  titleAr,
  textAr,
}: {
  titleEn: string;
  textEn: string;
  titleAr: string;
  textAr: string;
}) {
  if (!titleEn && !textEn && !titleAr && !textAr) return null;
  return (
    <div aria-label="Banner preview" role="group" className="grid gap-2 sm:grid-cols-2">
      {[
        { title: titleEn, text: textEn, dir: 'ltr' as const, lang: 'en' },
        { title: titleAr, text: textAr, dir: 'rtl' as const, lang: 'ar' },
      ].map((banner) => (
        <div
          key={banner.lang}
          dir={banner.dir}
          lang={banner.lang}
          className="bg-primary text-primary-foreground flex items-start gap-2 rounded-md px-3 py-2"
        >
          <BadgePercent className="mt-0.5 size-4 shrink-0" aria-hidden />
          <div className="min-w-0">
            <p className="truncate font-semibold">{banner.title || '—'}</p>
            {banner.text && <p className="opacity-90">{banner.text}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}
